/** @prettier */
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React, { useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';

import { PRODUCT_ROUTES } from '../../../constants';

import styles from './Breadcrumbs.module.scss';

const el = document.createElement('div');
document.body.appendChild(el);

export default function Breadcrumbs({ segments, tags, product }) {
  const nodeRef = useRef();

  const productUrlPrefix = PRODUCT_ROUTES[product];

  const breadcrumbs = useMemo(() => {
    const segmentUrls = segments.reduce(
      (arr, segment) => {
        arr.push(`${arr[arr.length - 1]}${segment}/`);
        return arr;
      },
      ['/']
    );

    const crumbs = segmentUrls.slice(1).reduce((acc, segment) => {
      const tag = tags.find(({ url }) => url === segment.slice(0, -1));

      if (tag && !['COUNTRY', 'LOCATION', 'OTHER'].includes(tag.type)) {
        acc.push(tag);
      }

      return acc;
    }, []);

    return crumbs;
  }, [segments.join('/'), tags]);

  return (
    <div>
      <nav ref={nodeRef} className={styles.breadcrumbs}>
        {breadcrumbs.filter(Boolean).map((tag) => (
          <Link
            key={tag.url}
            className={styles.breadcrumb}
            to={`${productUrlPrefix}/events${tag.url}`}
          >
            {tag.url.includes('live-betting') ? 'In-Play Betting' : tag.name}
            <span>|</span>
          </Link>
        ))}
      </nav>
    </div>
  );
}

Breadcrumbs.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.string).isRequired,
  tags: PropTypes.instanceOf(List).isRequired,
  product: PropTypes.string.isRequired,
};

Breadcrumbs.defaultProps = {
  noSelect: false,
};
